import React from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import DatasetIcon from '@mui/icons-material/Dataset';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import ViewModuleIcon from '@mui/icons-material/ViewModule';

export const BannerInfoBaseConocimiento = () => {
    return (
        <Paper 
            elevation={0}
            sx={{ 
                mt: 3, 
                p: { xs: 3, md: 4 }, 
                backgroundColor: '#F8F7FA', // Color de fondo muy suave
                borderRadius: 3,
                border: '1px solid #EAEAFF',
                mb: 3
            }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 4, flexWrap: 'wrap', gap: 2 }}>
                <Box sx={{ display: 'flex', gap: 2, flex: 1, minWidth: '300px' }}>
                    <Box 
                        sx={{ 
                            width: 52, 
                            height: 52, 
                            borderRadius: '50%', 
                            backgroundColor: '#E8E7FD', 
                            display: 'flex', 
                            justifyContent: 'center', 
                            alignItems: 'center',
                            flexShrink: 0
                        }}
                    >
                        <AutoAwesomeIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                    </Box>
                    <Box>
                        <Typography variant="h6" sx={{ color: '#696CFF', fontWeight: 700, mb: 0.5, fontSize: '1.15rem' }}>
                            ¿Qué es una Base de Conocimiento?
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500, maxWidth: '80%' }}>
                            Desde este módulo puedes administrar las fuentes de datos y repositorios de documentos que serán utilizados por los Agentes y Asistentes de IA para consultar información.
                        </Typography>
                    </Box>
                </Box>
            </Box>

            <Grid container spacing={3} sx={{ pl: { xs: 0, sm: 8.5 } }}>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Box sx={{ display: 'flex', gap: 1.5 }}>
                        <DatasetIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                        <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'text.primary', mb: 0.5 }}>
                                Documentos y Datos
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                                Registra colecciones de documentos para ser vectorizados y almacenados en embeddings.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Box sx={{ display: 'flex', gap: 1.5 }}>
                        <SmartToyIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                        <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'text.primary', mb: 0.5 }}>
                                Modelos de Embedding
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                                Configura el proveedor y modelo de IA que se utilizará para generar el conocimiento.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Box sx={{ display: 'flex', gap: 1.5 }}>
                        <ViewModuleIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                        <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'text.primary', mb: 0.5 }}>
                                Vectores y Chunks
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                                Monitorea el progreso del procesamiento y la cantidad de fragmentos indexados.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    );
};

